import { Button, DropdownMenu } from 'components/atoms';

import { t } from 'i18next';

import { PiCheck, PiPencilSimpleLine, PiUserSwitch } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';

import { DescriptiveInputWrapper, LabeledStatus } from 'components/molecules';
import { useComponentVisible } from 'hooks';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import LabelBanking from './LabelBanking';
import LabelBasicInformation from './LabelBasicInformation';
import LabelBilingAddres from './LabelBilingAddres';
import LabelContactDetails from './LabelContactDetails';
import LabelTaxOffice from './LabelTaxOffice';

import HeaderStatusWrapper from 'components/molecules/headerStatusWrapper/HeaderStatusWrapper';
import { useIsUserBanned } from 'hooks/useIsUserBanned';
import { useStoreState } from 'providers/StoreStateContext';
import { useGetAccounts, useSwitchAccount } from 'services/account';
import { useGetLabel } from 'services/labels';
import DataWrapper from 'components/molecules/data-wrapper/DataWrapper';
import ViewHint from 'components/molecules/hint/ViewHint';
import { STATUS } from 'services/types';
import { LABEL_STATUS } from 'services/labels/types';
import AccountSelectPopupForm from 'components/molecules/popup/account-select/AccountSelectPopupForm';

const Label = () => {
  const navigate = useNavigate();

  const { data: label, isLoading } = useGetLabel();
  const { data: accounts } = useGetAccounts();

  const { ref, isComponentVisible, handleComponentVisible } =
    useComponentVisible<HTMLDivElement>(false);

  const switchAccount = useSwitchAccount();

  const { token, tokenData } = useStoreState();

  const handlePickAccount = async (accountId: string) => {
    if (!token) return;

    if (accountId === tokenData?.CurrentAccount) {
      handleComponentVisible();
      return;
    }

    await switchAccount.mutateAsync(
      { token, accountId },
      {
        onSuccess: () => {
          handleComponentVisible();
        },
      },
    );
  };

  const { isBanned } = useIsUserBanned();
  const labelStatus = label?.labelStatus;
  console.log('labelStatus', labelStatus ? LABEL_STATUS[labelStatus] : undefined, LABEL_STATUS);
  return (
    <DataWrapper>
      <LabelBasicInformation />
      <LabelContactDetails />
      <LabelBilingAddres />
      <LabelTaxOffice />
      <LabelBanking />

      {accounts && accounts.length > 1 && (
        <>
          <div />
          <ViewHint hintId="label-account-switch" />
          <AccountSelectPopupForm
            accounts={accounts}
            currentAccountId={tokenData?.CurrentAccount}
            isLoading={switchAccount.isPending}
            onSave={(accountId, actions) => {
              handlePickAccount(accountId);
              actions.close();
            }}
            trigger={
              <Button fullWidth variant={BUTTON_VARIANT.white}>
                <Button.Text text={t('button.switchAccount')} />
                <Button.Icon icon={<PiUserSwitch />} />
              </Button>
            }
          />
        </>
      )}
      <div />
      <ViewHint hintId={labelStatus ? `label-status.${LABEL_STATUS[labelStatus]}` : undefined} />
      <div />
      {!isBanned && (
        <div
          className="flex sticky gap-2 bottom-8 w-full max-w-[500px] p-8 rounded z-10"
          style={{
            background: 'var(--background)',
            filter: 'drop-shadow(0 0 10px var(--app-background))',
          }}
        >
          <Button
            fullWidth
            variant={BUTTON_VARIANT.submit}
            onClick={() => {
              label &&
                navigate(`/label-form`, {
                  replace: true,
                });
            }}
          >
            {' '}
            <Button.Icon icon={<PiPencilSimpleLine />} />
            <Button.Text text={t('button.edit')} />
          </Button>
        </div>
      )}
    </DataWrapper>
  );
};

export default Label;
